/* eslint-disable */
import moment from 'moment';
import React, { useEffect, useState } from 'react'
import { api_url } from '../../Constants/web_services';
import CompanyOrderReviews from './CompanyOrderReviews';

const CompanyReview = ({ company: companyData }) => {

    const [review, setReviews] = useState('')
    const [quality, setQuality] = useState('')
    const [timeline, setTimeline] = useState('')
    const [responseTime, setResponseTime] = useState('')
    const [cancelOrder, setCancelOrder] = useState('')
    const [orderIn, setOrderIn] = useState('')
    const [completeOd, setCompleteOd] = useState('')

    const getReviews = (companyId) => {
        const apiUrl = api_url + `/api/company-order-reviews/${companyId}`;
        fetch(apiUrl)
            .then((response) => {
                if (!response.ok) {
                    throw new Error("Network response was not ok");
                }
                return response.json();
            })
            .then((data) => {
                // console.log(data?.review, 'data r')
                setReviews(data?.review);
                setQuality(data?.quality)
                setTimeline(data?.timeline)
                setResponseTime(data?.response_time)
                setCancelOrder(data?.cancelOrder)
                setOrderIn(data?.order)
                setCompleteOd(data?.complete_od)
            })
            .catch((error) => {
                // Handle errors if any
                console.error("Error fetching company data:", error);
            });
    };

    useEffect(() => {
        getReviews(companyData?.id);
    }, [companyData?.id]);

    const renderStars = (rating) => {
        const totalStars = 5;
        const fullStars = Math.floor(rating);
        const hasHalfStar = rating % 1 !== 0;

        return (
            <div className="sf-ow-pro-rating">
                {[...Array(totalStars)].map((_, i) => {
                    if (i < fullStars) {
                        return <span key={i} className="fa fa-star" />;
                    } else if (i === fullStars && hasHalfStar) {
                        return <span key={i} className="fa fa-star-half-o" />;
                    } else {
                        return <span key={i} className="fa fa-star text-022279 font-size-12" />;
                    }
                })}
            </div>
        );
    };

    return (
        <>
            <div className="container">
                <div
                    id="aon-provider-coRep"

                    className="sf-provi-articles-box margin-b-50 sf-provi-fullBox "
                >
                    <h3 className="sf-provi-title s-18 fw-800 text-drk-primary">Company Reputaion</h3>
                    <div className="sf-divider-line" />
                    <div className="sf-rating-outer sf-rating-outer-border row justify-content-around">
                        <div className="col-md-5 mt-3 mt-3 sf-rating-averages-wraps sf-rating-averages-new">
                            <h3 className='text-center'>Company Order Scores</h3>



                            <div className="sf-rating-categories-table" style={{ height: '35px' }}>
                                <div className="sf-rating-categories-cell">In Progress Orders</div>
                                <div className="sf-rating-categories-cell">
                                    <div className="sf-reviews-row">
                                        <div className="sf-reviews-star">


                                        </div>
                                        <div className={`sf-reviews-star-no  ${!orderIn ? "text-danger" : "text-success"}`}> {orderIn === null ? "NAN" : orderIn?.length}</div>
                                    </div>
                                </div>
                            </div>

                            <div className="sf-rating-categories-table" style={{ height: '35px' }}>
                                <div className="sf-rating-categories-cell">Completed tasks</div>
                                <div className="sf-rating-categories-cell">
                                    <div className="sf-reviews-row">
                                        <div className="sf-reviews-star">


                                        </div>
                                        <div className={`sf-reviews-star-no  ${!completeOd ? "text-danger" : "text-success"}`}> {completeOd === null ? "NAN" : completeOd?.length}</div>
                                    </div>
                                </div>
                            </div>

                            <div className="sf-rating-categories-table" style={{ height: '35px' }}>
                                <div className="sf-rating-categories-cell">Order Cancel</div>
                                <div className="sf-rating-categories-cell">
                                    <div className="sf-reviews-row">
                                        <div className="sf-reviews-star">


                                        </div>
                                        <div className={`sf-reviews-star-no  ${!cancelOrder ? "text-danger" : "text-success"}`}>{cancelOrder === null ? 'NAN' : cancelOrder?.length}</div>


                                    </div>
                                </div>
                            </div>

                        </div>
                        <div className="col-md-5 mt-3 sf-rating-categories-wraps sf-rating-categories-new">
                            <h3 className='text-center'>Company Scores</h3>
                            <div className="sf-rating-categories-table" style={{ height: '35px' }}>
                                <div className="sf-rating-categories-cell">Quality</div>
                                <div className="sf-rating-categories-cell">
                                    <div className="sf-reviews-row">
                                        <div className="sf-reviews-star">

                                            {renderStars(quality)}

                                        </div>
                                        <div className={`sf-reviews-star-no font-size-12 ${!quality ? "text-danger" : "text-success"}`}> &nbsp;&nbsp;{quality * 2} / 10</div>
                                    </div>
                                </div>
                            </div>
                            <div className="sf-rating-categories-table" style={{ height: '35px' }}>
                                <div className="sf-rating-categories-cell">TimeLine</div>
                                <div className="sf-rating-categories-cell">
                                    <div className="sf-reviews-row">
                                        <div className="sf-reviews-star">

                                            {renderStars(timeline)}

                                        </div>
                                        <div className={`sf-reviews-star-no font-size-12 ${!timeline ? "text-danger" : "text-success"}`}> &nbsp;&nbsp;{timeline * 2} / 10</div>
                                    </div>
                                </div>
                            </div>

                            <div className="sf-rating-categories-table" style={{ height: '35px' }}>
                                <div className="sf-rating-categories-cell">Response Time</div>
                                <div className="sf-rating-categories-cell">
                                    <div className="sf-reviews-row">
                                        <div className="sf-reviews-star">

                                            {renderStars(responseTime)}

                                        </div>


                                        <div className={`sf-reviews-star-no font-size-12 ${!responseTime ? "text-danger" : "text-success"}`}> &nbsp;&nbsp;{responseTime * 2} / 10</div>

                                    </div>
                                </div>
                            </div>
                            <div className="sf-rating-categories-table">
                                <div className="sf-rating-categories-cell">Registered At</div>
                                <div className="sf-rating-categories-cell">
                                    <div className="sf-reviews-row">
                                        <div className="sf-reviews-star">
                                            {" "}
                                            {/* <i className="fa fa-star" /> <i className="fa fa-star" /> */}
                                        </div>
                                        <div className="sf-reviews-star-no">
                                            <span className='text-drk-primary fw-600 font-size-12'>{moment(companyData?.created_at).format('MMMM Do YYYY')}</span>
                                            <br />
                                            <p>{moment(companyData?.created_at, "YYYYMMDD").fromNow()}</p></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <CompanyOrderReviews company={companyData} />

                </div>
            </div>
        </>
    )
}

export default CompanyReview